export const HOUSE_ROT = {
  nickname: 'PRODUCTS.HOUSE_ROT.shortname',
  isHidden: true,
  icon:'house-rot'
};
